import { useDispatch, useSelector } from "react-redux";
import { fetchAvgValue } from "../controller/services/common";
import { getCategoryData, getRelevantData } from "../utils/helper";
import { setLoading } from "../redux/slices/common_slice";
import i18n from "../localization/i18n";

export default function useAvgValue() {
  const userData = useSelector((state) => state.form.userData);
  const dispatch = useDispatch();
  const fetchAvgVal = async (endpoint, item_name, FETCH_FOR_ONE) => {
    const foundChildren =
      (userData?.houseHold?.length > 0 &&
        userData?.houseHold?.find((i) => i.type === "children")?.count) ||
      0;
    const foundMembers =
      (userData?.houseHold?.length > 0 &&
        userData?.houseHold?.find((i) => i.type === "otherMembers")?.count) ||
      0;
    const isMyself =
      userData?.houseHold?.length > 0 &&
      userData?.houseHold?.find((i) => i?.type === "myself");
    const isPartner =
      userData?.houseHold?.length > 0 &&
      userData?.houseHold?.find((i) => i?.type === "partner");
    let totalMembers = Number(foundMembers);
    if (isMyself) {
      totalMembers = Number(totalMembers) + 1;
    }
    if (isPartner) {
      totalMembers = Number(totalMembers) + 1;
    }
    dispatch(setLoading(true));
    const payload = {
      city: `${userData?.city || userData?.cityNew}, Canada`,
      endpoint: endpoint,
      rent: true,
      members: FETCH_FOR_ONE ? 1 : totalMembers,
      children: Number(foundChildren),
    };
    try {
      let relevantData;
      const resp = await fetchAvgValue(payload);
      if (resp?.data?.error) {
        console.log(resp?.data?.error);
      } else if (resp?.data?.breakdown?.length > 0) {
        relevantData = getCategoryData(resp.data.breakdown, item_name);
      } else {
        relevantData = getRelevantData(resp.data.prices, item_name);
      }
      return relevantData;
    } catch (err) {
      console.error(err.message?.[i18n.language]);
    } finally {
      dispatch(setLoading(false));
    }
  };
  return { fetchAvgVal };
}
